module.exports = __webpack_public_path__ + "img/2.1597a5b2.png";